import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useIsPro } from "../imports";

export default function Control() {
	let { projectId } = useParams();
	const [outputNumber, setOutputNumber] = useState('')

	const isPro = useIsPro()

	return (
		<div className="p-1 bg-gray-800 w-screen h-screen flex flex-col md:grid grid-cols-2 grid-rows-6 md:grid-rows-2 gap-1">
			<div className="relative hidden md:inline h-full w-100 my-auto row-span-1 row-start-1 md:row-start-1">
				<div className="pr-0.5 pb-0.5 absolute text-xxs uppercase font-semibold text-gray-200 bg-gray-800 rounded-br opacity-50 md:opacity-100">
					Preview
				</div>
				<iframe
					title="Preview"
					style={{
						height: "inherit",
						width: "-webkit-fill-available",
						aspectRatio: "16 / 9 !important",
					}}
					className="rounded"
					src={`/preview/${projectId}`}
				/>
			</div>
			<div className="relative my-auto h-full row-span-1 row-start-1 md:row-start-2">
				<span className="pr-0.5 pb-0.5 absolute text-xxs uppercase font-semibold text-gray-200 bg-gray-800 rounded-br opacity-50 md:opacity-100">
				<div className="flex gap-1">
						<p className="mr-2">Output</p>
						{isPro &&
						<>
							<button
							onClick={()=>{setOutputNumber('')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputNumber === '' ? 'bg-red-500': 'bg-gray-700'
							].join(' ')}>1</button>
							<button
							onClick={()=>{setOutputNumber('2')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputNumber === '2' ? 'bg-red-500': 'bg-gray-700'
							].join(' ')}>2</button>
							<button
							onClick={()=>{setOutputNumber('3')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputNumber === '3' ? 'bg-red-500': 'bg-gray-700'
							].join(' ')}>3</button>
							<button
							onClick={()=>{setOutputNumber('4')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputNumber === '4' ? 'bg-red-500': 'bg-gray-700'
							].join(' ')}>4</button>
							<button
							onClick={()=>{setOutputNumber('utility')}}
							className={[
								'px-1 min-w-[1rem] rounded-sm',
								outputNumber === 'utility' ? 'bg-red-500': 'bg-gray-700'
							].join(' ')}>Utility</button>
						</>
						}
					</div>
				</span>
				<iframe
					title="Output"
					style={{
						height: "inherit",
						width: "-webkit-fill-available",
						aspectRatio: "16 / 9 !important",
					}}
					className="rounded "
					src={`/output/${projectId}/${outputNumber}${outputNumber === 'utility' ? '?bg=%23212121' : ''}`}
				/>
			</div>
			<iframe
				title="Rundown"
				className="w-full h-full rounded row-span-6 md:row-span-2 col-span-2 md:col-span-1"
				src={`/rundown/${projectId}`}
			/>
		</div>
	);
}
